import React from 'react';
import { alacarte, commercialPackages } from '../mock/mockData';
import { Button } from './ui/button';

export const AdditionalServices = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* À La Carte Services */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">À La Carte Add-Ons</h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              Customize your service with our flexible add-on options
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {alacarte.map((service, idx) => (
              <div
                key={idx}
                className="bg-slate-50 rounded-xl p-6 border border-slate-200 hover:border-blue-300 hover:shadow-lg transition-all duration-300"
              >
                <div className="flex justify-between items-start mb-3">
                  <h3 className="text-lg font-bold text-slate-900 flex-1">{service.name}</h3>
                  <span className="text-blue-600 font-bold text-lg whitespace-nowrap ml-4">{service.price}</span>
                </div>
                <p className="text-slate-600 text-sm leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Commercial Packages */}
        <div>
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Commercial & Real Estate</h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              Specialized services for realtors and property managers
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {commercialPackages.map((pkg, idx) => (
              <div
                key={idx}
                className="bg-slate-900 text-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300"
              >
                <h3 className="text-2xl font-bold mb-3">{pkg.name}</h3>
                <div className="text-3xl font-bold text-blue-400 mb-6">{pkg.price}</div>
                <p className="text-slate-300 leading-relaxed mb-6">{pkg.description}</p>
                <Button
                  onClick={scrollToContact}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white"
                >
                  Request Information
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
